import GenerateGasOrder from './GenerateGasOrder';

export default GenerateGasOrder;
